(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mars-before-after"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.mars-ba__carousel').forEach(function (car) {
    var track = car.querySelector('.mars-ba__track');
    if (!track) return;
    car.querySelectorAll('.mars-ba__arrow').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var card = track.querySelector('.mars-ba__card');
        var step = card ? card.offsetWidth + 16 : 320;
        track.scrollBy({ left: btn.dataset.dir === 'next' ? step : -step, behavior: 'smooth' });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mars-buybox-v2"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.mars-bb2__gallery-nav').forEach(function (nav) {
      var strip = nav.querySelector('.mars-bb2__thumbs');
      if (!strip) return;
      var main = document.getElementById(strip.dataset.main);
      var thumbs = Array.prototype.slice.call(strip.querySelectorAll('.mars-bb2__thumb'));
      function activate(i) {
        if (i < 0) i = thumbs.length - 1;
        if (i >= thumbs.length) i = 0;
        var btn = thumbs[i];
        if (!btn || !main) return;
        main.removeAttribute('srcset');
        main.removeAttribute('sizes');
        main.src = btn.dataset.src;
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        btn.classList.add('is-active');
        btn.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      }
      strip.addEventListener('click', function (e) {
        var btn = e.target.closest('.mars-bb2__thumb');
        if (btn) activate(thumbs.indexOf(btn));
      });
      nav.querySelectorAll('.mars-bb2__arrow').forEach(function (arrow) {
        arrow.addEventListener('click', function () {
          var cur = thumbs.findIndex(function (t) { return t.classList.contains('is-active'); });
          activate(arrow.dataset.dir === 'next' ? cur + 1 : cur - 1);
        });
      });

      // swipe the main image to change photo (mobile + trackpad/mouse drag)
      if (main) {
        var swipeEl = main.closest('.mars-bb2__card') || main;
        var sx = 0, sy = 0, tracking = false;
        function curIndex() { return thumbs.findIndex(function (t) { return t.classList.contains('is-active'); }); }
        function onStart(x, y) { sx = x; sy = y; tracking = true; }
        function onEnd(x, y) {
          if (!tracking) return;
          tracking = false;
          var dx = x - sx, dy = y - sy;
          if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
            activate(dx < 0 ? curIndex() + 1 : curIndex() - 1);
          }
        }
        swipeEl.addEventListener('touchstart', function (e) { var t = e.touches[0]; onStart(t.clientX, t.clientY); }, { passive: true });
        swipeEl.addEventListener('touchend', function (e) { var t = e.changedTouches[0]; onEnd(t.clientX, t.clientY); }, { passive: true });
        swipeEl.addEventListener('pointerdown', function (e) { if (e.pointerType === 'mouse') onStart(e.clientX, e.clientY); });
        swipeEl.addEventListener('pointerup', function (e) { if (e.pointerType === 'mouse') onEnd(e.clientX, e.clientY); });
        swipeEl.style.touchAction = 'pan-y';
      }
    });
  })();

  (function () {
    document.querySelectorAll('[data-rev-slider]').forEach(function (sl) {
      var track = sl.querySelector('.mars-bb2__rev-track');
      if (!track) return;
      var down = false, startX = 0, startScroll = 0, moved = false;
      track.addEventListener('pointerdown', function (e) {
        down = true; moved = false; startX = e.clientX; startScroll = track.scrollLeft;
        try { track.setPointerCapture(e.pointerId); } catch (err) {}
        track.style.cursor = 'grabbing';
      });
      track.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - startX;
        if (Math.abs(dx) > 4) moved = true;
        track.scrollLeft = startScroll - dx;
      });
      function settle() {
        if (!down) return;
        down = false; track.style.cursor = 'grab';
        var w = track.clientWidth;
        track.scrollTo({ left: Math.round(track.scrollLeft / w) * w, behavior: 'smooth' });
      }
      track.addEventListener('pointerup', settle);
      track.addEventListener('pointercancel', settle);
      track.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mars-buybox"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.mars-bb__gallery-nav').forEach(function (nav) {
      var strip = nav.querySelector('.mars-bb__thumbs');
      if (!strip) return;
      var main = document.getElementById(strip.dataset.main);
      var thumbs = Array.prototype.slice.call(strip.querySelectorAll('.mars-bb__thumb'));
      function activate(i) {
        if (i < 0) i = thumbs.length - 1;
        if (i >= thumbs.length) i = 0;
        var btn = thumbs[i];
        if (!btn || !main) return;
        main.removeAttribute('srcset');
        main.removeAttribute('sizes');
        main.src = btn.dataset.src;
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        btn.classList.add('is-active');
        btn.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      }
      strip.addEventListener('click', function (e) {
        var btn = e.target.closest('.mars-bb__thumb');
        if (btn) activate(thumbs.indexOf(btn));
      });
      nav.querySelectorAll('.mars-bb__arrow').forEach(function (arrow) {
        arrow.addEventListener('click', function () {
          var cur = thumbs.findIndex(function (t) { return t.classList.contains('is-active'); });
          activate(arrow.dataset.dir === 'next' ? cur + 1 : cur - 1);
        });
      });

      // swipe the main image to change photo (mobile + trackpad/mouse drag)
      if (main) {
        var swipeEl = main.closest('.mars-bb__card') || main;
        var sx = 0, sy = 0, tracking = false;
        function curIndex() { return thumbs.findIndex(function (t) { return t.classList.contains('is-active'); }); }
        function onStart(x, y) { sx = x; sy = y; tracking = true; }
        function onEnd(x, y) {
          if (!tracking) return;
          tracking = false;
          var dx = x - sx, dy = y - sy;
          if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
            activate(dx < 0 ? curIndex() + 1 : curIndex() - 1);
          }
        }
        swipeEl.addEventListener('touchstart', function (e) { var t = e.touches[0]; onStart(t.clientX, t.clientY); }, { passive: true });
        swipeEl.addEventListener('touchend', function (e) { var t = e.changedTouches[0]; onEnd(t.clientX, t.clientY); }, { passive: true });
        swipeEl.addEventListener('pointerdown', function (e) { if (e.pointerType === 'mouse') onStart(e.clientX, e.clientY); });
        swipeEl.addEventListener('pointerup', function (e) { if (e.pointerType === 'mouse') onEnd(e.clientX, e.clientY); });
        swipeEl.style.touchAction = 'pan-y';
      }
    });
  })();

  (function () {
    document.querySelectorAll('[data-rev-slider]').forEach(function (sl) {
      var track = sl.querySelector('.mars-bb__rev-track');
      if (!track) return;
      var down = false, startX = 0, startScroll = 0, moved = false;
      track.addEventListener('pointerdown', function (e) {
        down = true; moved = false; startX = e.clientX; startScroll = track.scrollLeft;
        try { track.setPointerCapture(e.pointerId); } catch (err) {}
        track.style.cursor = 'grabbing';
      });
      track.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - startX;
        if (Math.abs(dx) > 4) moved = true;
        track.scrollLeft = startScroll - dx;
      });
      function settle() {
        if (!down) return;
        down = false; track.style.cursor = 'grab';
        var w = track.clientWidth;
        track.scrollTo({ left: Math.round(track.scrollLeft / w) * w, behavior: 'smooth' });
      }
      track.addEventListener('pointerup', settle);
      track.addEventListener('pointercancel', settle);
      track.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mars-header"] && !Shopify.designMode) return;
  try {
    
  class MarsHeader extends HTMLElement {
    connectedCallback() {
      var burger = this.querySelector('.mars-hd__burger');
      var drawer = this.querySelector('.mars-hd__drawer');
      if (burger && drawer) {
        burger.addEventListener('click', function () {
          var open = drawer.hasAttribute('hidden');
          if (open) { drawer.removeAttribute('hidden'); } else { drawer.setAttribute('hidden', ''); }
          burger.setAttribute('aria-expanded', String(open));
        });
      }
    }
  }
  if (!customElements.get('mars-header')) customElements.define('mars-header', MarsHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mars-ingredients"] && !Shopify.designMode) return;
  try {
    
  class MarsIngredients extends HTMLElement {
    connectedCallback() {
      var track = this.querySelector('[data-track]');
      if (!track) return;
      var prev = this.querySelector('[data-dir="prev"]');
      var next = this.querySelector('[data-dir="next"]');
      function step() {
        var card = track.querySelector('.mars-ing__card');
        if (!card) return track.clientWidth;
        var styles = getComputedStyle(track);
        var gap = parseInt(styles.columnGap || styles.gap || '16', 10) || 16;
        return card.getBoundingClientRect().width + gap;
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });

      // drag-to-scroll (desktop pointer)
      var down = false, startX = 0, startScroll = 0, moved = false;
      track.addEventListener('pointerdown', function (e) { down = true; moved = false; startX = e.clientX; startScroll = track.scrollLeft; });
      track.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - startX;
        if (Math.abs(dx) > 4) moved = true;
        track.scrollLeft = startScroll - dx;
      });
      function end() { down = false; }
      track.addEventListener('pointerup', end);
      track.addEventListener('pointerleave', end);
      track.addEventListener('click', function (e) { if (moved) { e.preventDefault(); } }, true);
    }
  }
  if (!customElements.get('mars-ingredients')) customElements.define('mars-ingredients', MarsIngredients);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mars-tabs"] && !Shopify.designMode) return;
  try {
    
  class MarsTabs extends HTMLElement {
    connectedCallback() {
      var tabs = Array.prototype.slice.call(this.querySelectorAll('[data-tab]'));
      var panels = Array.prototype.slice.call(this.querySelectorAll('[data-panel]'));
      var self = this;
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var id = tab.getAttribute('data-tab');
          tabs.forEach(function (t) {
            var on = t === tab;
            t.classList.toggle('is-active', on);
            t.setAttribute('aria-selected', on ? 'true' : 'false');
          });
          panels.forEach(function (p) { p.hidden = p.getAttribute('data-panel') !== id; });
        });
      });
    }
  }
  if (!customElements.get('mars-tabs')) customElements.define('mars-tabs', MarsTabs);

  } catch(e) { console.error(e); }
})();
})();
